<app-modal [maskClose]="maskClose" [id]="modalId">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div class='header'>
        <p >Cancel Your Written Word Media Membership</p>
      </div>
      <div class="content">
        <p>We're sorry you are thinking about canceling your {{membershipLevel}} Membership.</p>  
        <p> By clicking cancel below your {{membershipLevel}} Membership will be canceled, and will not renew on
           {{moment(currentSubscription.renewal).format('MMMM Do, YYYY')}}. You will still have access to {{membershipLevel}}
            Membership benefits from now until {{moment(currentSubscription.renewal).format('MMMM Do, YYYY')}}.</p>
        <p>Are you sure you want to cancel?</p>
      </div>
      <div class="footer">
        <button class="button regular solid-green" (click)="cancelPlan()">
          Yes I’m sure, cancel my {{membershipLevel}} Membership
        </button>
        <button class="button regular grey" (click)="close()">
          No Thanks, I’ll keep my {{membershipLevel}} Membership for now!
        </button>
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
